import appConfigCoverGoDev from "./appConfigCoverGoDev.js"
import { COVERGO_ASIA_PRE_PROD } from "../consts.js"

export const coverHealthAsiaPreprod = {
	"studio.preprod.asia.covergo.cloud": { appConfig: appConfigCoverGoDev, envConfig: COVERGO_ASIA_PRE_PROD },
}
